<template>
  <el-button :icon='icon' :loading='loading' :round='round' :size='fieldSize' :type='type'
             @click="(click)? click() : $emit('click')"
             class='devegram-input-button-field'>
    {{ (translate) ? $ml.get(text) : text }}
  </el-button>
</template>

<script>
export default {
  props: {
    click: {
      required: false,
      default: false
    },
    fieldSize: {
      required: false,
      defafult: 'small'
    },
    loading: {
      required: false,
      defafult: false
    },
    round: {
      required: false,
      defafult: false
    },
    text: {
      required: true
    },
    icon: {
      required: false
    },
    type: {
      required: false,
      default: 'info'
    },
    translate: {
      required: false,
      default: true
    }
  }
}
</script>
